
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { mdiChevronDown } from '@mdi/js';
import { VuetifyMixin } from '../../mixins';

@Component
export default class ExpandingCard extends Mixins(VuetifyMixin){
	mdiChevronDown = mdiChevronDown;

	@Prop() private icon: string;
	@Prop({ default: 'baColorDeepBlue' }) private headerColor: string;
	@Prop({ default: true, type: Boolean }) private headerDark: boolean;
	@Prop({ default: false, type: Boolean }) private outlined: boolean;
	@Prop({ default: 'baColorAppForeground' }) private bodyColor: string;
	@Prop({ default: false, type: Boolean }) private bodyDark: boolean;
	@Prop({ default: null }) private minWidth: string | null;

	get MinWidth(): string{
		return `${this.minWidth}px`;
	}
	get CardStyle(): Record<string, any>{
		return {
			'min-width': this.minWidth === null ? undefined : this.MinWidth,
		}
	}

	clickedExpand(): void{
		if(this.isExpanded){
			this.$emit('click:less');
		}else{
			this.$emit('click:more');
		}
	}

	get LargeScreen(): boolean{
		return this.$vuetify.breakpoint.lgAndUp;
	}

	get HeaderColor(): string{
		return this.getColor(this.headerColor);
	}
	get BodyColor(): string{
		return this.getColor(this.bodyColor);
	}

	get ExpandIconColor(): string{
		if(this.bodyDark){
			return 'white';
		}else{
			return 'baColorVibrantBlue';
		}
	}
	@Prop({ type: Boolean, default: false }) isExpanded: boolean;
	get ExpandText(): string{
		if(this.isExpanded){
			return 'Less';
		}else{
			return 'More';
		}
	}
	get HasExpansionContent(): boolean{
		return this.$scopedSlots['expanded'] !== undefined;
	}
	get HasExpansionXContent(): boolean{
		return this.$scopedSlots['expanded-x'] !== undefined && this.isExpanded;
	}

}
